import { ConfigEditor } from "./ConfigEditor.js";
import { ExecutionView } from "./ExecutionView.js";
import { Icon } from "./Icon.js";
import { configSchema, dataSchema, defaultConfig } from "./schema.js";
export const linkExternalPlugin = {
    slug: "link-external",
    name: "External Link",
    description: "Navigate to an external URL and confirm completion",
    type: "link",
    completionType: "user_confirm",
    configSchema,
    dataSchema,
    defaultConfig,
    handlers: {
        onStart: (ctx) => {
            ctx.logger.info("External link action started", {
                actionId: ctx.execution.moduleActionId,
                url: ctx.config.url,
            });
            return Promise.resolve();
        },
        onComplete: (ctx, data) => {
            ctx.logger.info("External link confirmed", {
                actionId: ctx.execution.moduleActionId,
                clickedAt: data.clickedAt,
            });
            return Promise.resolve();
        },
    },
    components: {
        Icon,
        ConfigEditor,
        ExecutionView,
    },
    order: 4,
    version: "1.0.0",
    author: "Unios Team",
};
//# sourceMappingURL=index.js.map